import { getSymbol, TreeSymbol } from '@mairistem/finances-utils';
import { isNil } from 'lodash';
import TypeRegroupement from '../constants/feuilleSaisie/typeRegroupement';
import type TreeRow from '../interfaces/feuilleSaisie/treeRow';

export interface CreateImputation {
	codeChapitre: string;
	codeArticle: string;
	codeFonction: string;
	codeOperation: string;
	codeVentilation: string;
	codeAnalytique: string;
	sens: string;
	section: string;
	cha_libelle?: string;
	art_libelle?: string;
	fon_libelle?: string;
	ope_libelle?: string;
	ven_libelle?: string;
	ana_libelle?: string;
}

export const checkImputation = (imputation: CreateImputation) => {
	if (isNil(imputation?.sens)) {
		throw new Error('Le sens est obligatoire');
	}

	if (isNil(imputation?.section)) {
		throw new Error('La section est obligatoire');
	}

	if (isNil(imputation?.codeChapitre)) {
		throw new Error('La chapitre est obligatoire');
	}

	if (isNil(imputation?.codeArticle)) {
		throw new Error("L'article est obligatoire");
	}

	if (imputation?.section === 'I' && isNil(imputation?.codeOperation)) {
		throw new Error("L'opération est obligatoire en investissement");
	}
};

const getRegroupementLibelle = (rowData: TreeRow): string[] => {
	const result = [];
	rowData?.typesRegroupement?.forEach((typeRegroupement) => {
		if (typeRegroupement.code !== TypeRegroupement.IMPUTATION) {
			result.push(rowData?.[typeRegroupement.codeColumnName]);
		}
	});

	return result;
};

export const getImputationText = (rowData: TreeRow): string => {
	let parent: TreeRow = getSymbol(rowData, TreeSymbol.PARENT);
	// Si nous avons plusieurs elements de l'imputation.
	if (parent) {
		let codes = getRegroupementLibelle(rowData);
		// On remonte à chaque parent, et on récupère son code
		while (parent) {
			codes = getRegroupementLibelle(parent).concat(codes);
			parent = getSymbol(parent, TreeSymbol.PARENT);
		}

		return codes.join(' | ');
	}
	return getRegroupementLibelle(rowData).join(' | ');
};
